import posthog from 'posthog-js'

function createTracker(store) {
  const track = (eventName, props = {}) => {
    try {
      if (!posthog || typeof posthog.capture !== 'function') return
      posthog.capture(eventName, { ...props })
    } catch {}
  }

  return {
    track,

    vehicleSearchPerformed: ({ search_type }) => {
      track('vehicle_search_performed', { search_type })
    },

    vehicleIdentified: async ({ vehicle_id, search_type }) => {
      track('vehicle_identified', { vehicle_id: vehicle_id, search_type })
    },

    vehicleSearchFailed: ({ search_type, error_code }) => {
      track('vehicle_search_failed', { search_type, error_code })
    },

    checkinStarted: ({ vehicle_id }) => {
      track('checkin_started', { vehicle_id })
    },

    checkinSubmitted: ({ photos_count }) => {
      track('checkin_submitted', { photos_count })
    },

    estimateCreated: ({ estimate_id, lines_count, total_value }) => {
      track('estimate_created', { estimate_id, lines_count, total_value })
    },

    estimateSaved: ({ estimate_id, parts_count, labor_count }) => {
      track('estimate_saved', { estimate_id, parts_count, labor_count })
    },

    estimateShared: ({ estimate_id, channel }) => {
      track('estimate_shared', { estimate_id, channel })
    },

    estimateApproved: ({ estimate_id, parts_count, labor_count }) => {
      track('estimate_approved', { estimate_id, parts_count, labor_count })
    },

    estimateRejected: ({ estimate_id, parts_count, labor_count }) => {
      track('estimate_rejected', { estimate_id, parts_count, labor_count })
    },

    servicePlanningOpened: () => {
      track('service_planning_opened')
    },

    workorderScheduled: ({ duration_min }) => {
      track('workorder_scheduled', { duration_min })
    },

    serviceUpdated: ({ duration_min }) => {
      track('service_updated', { duration_min })
    },

    techinfoOpened: () => {
      track('techinfo_opened')
    },

    techinfoSectionOpened: ({ section, section_item, request }) => {
      track('techinfo_section_opened', { section, section_item, request })
    },

    techinfoArticleViewed: ({ doc_id, section, section_item, request }) => {
      track('techinfo_article_viewed', { doc_id, section, section_item, request })
    },

    supportPopupOpened: () => {
      track('support_popup_opened')
    },

    supportTicketSubmitted: ({ message_length }) => {
      track('support_ticket_submitted', { message_length })
    },

    campaignCreated: ({ campaign_id }) => {
      track('campaign_created', { campaign_id })
    },

    campaignSent: ({ campaign_id }) => {
      track('campaign_sent', { campaign_id })
    },

    ordersListViewed: () => {
      track('orders_list_viewed')
    },

    requestCreated: ({ type }) => {
      track('request_created', { type })
    },

    orderUpdated: () => {
      track('order_updated')
    },

    requestStatusChanged: ({ request_id, from_status, to_status }) => {
      track('request_status_changed', { request_id, from_status, to_status })
    },

    distributorRequestAction: ({ entity_id, operator_name, user_id, action_type, request_id, from_status, to_status }) => {
      track('distributor_request_action', { entity_id, operator_name, user_id, action_type, request_id, from_status, to_status })
    },

    requestOwnerChanged: ({ request_id, from_user_id, to_user_id }) => {
      track('request_owner_changed', { request_id, from_user_id, to_user_id })
    },

    webshopLinkClicked: () => {
      track('webshop_link_clicked')
    },

    dsbLinkClicked: () => {
      track('dsb_link_clicked')
    },

    notificationClicked: ({ notification_id, notification_type_id, title, has_link_cta, has_popup, was_unread, link_cta }) => {
      track('notification_clicked', {
        notification_id,
        notification_type_id,
        title,
        has_link_cta,
        has_popup,
        was_unread,
        link_cta,
      })
    }
  }
}

export default {
  install(Vue, { store } = {}) {
    Vue.prototype.$analytics = createTracker(store)
  }
}
